<template>
  <div class="bg-white p-8">
    <div class="w-full">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="Chat" name="first">
          <div class="mt-4">
            <h2 class="text-black font-semibold text-2xl">Chats overview</h2>
            <div class="grid grid-cols-3 gap-4 mt-5">
              <div
                class="p-8 shadow-md bg-white border rounded-lg"
                @click="filterStatus('Open')"
              >
                <div class="flex justify-between items-center w-full">
                  <h5 class="text-xl text-primary font-semibold">Open Chats</h5>
                  <!-- <feather-icon icon="ArrowRightIcon" svgClasses="w-5 h-5" /> -->
                </div>
                <!-- <p class="text-gray fsize12 mt-1">12+ Ongoing Chats</p> -->
                <div class="flex justify-between items-center w-full mt-6">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/Whatsapp/Sample4.png"
                    class="object-contain w-16 h-16 bg-ec rounded-full"
                    alt="banh"
                  />
                  <h2 class="text-5xl font-semibold col-89">
                    {{ AssignChat }}
                  </h2>
                </div>
              </div>
              <div
                class="p-8 shadow-md bg-white border rounded-lg"
                @click="filterStatus('Pending')"
              >
                <div class="flex justify-between items-center w-full">
                  <h5 class="text-xl text-primary font-semibold">
                    Pending Chats
                  </h5>
                  <!-- <feather-icon icon="ArrowRightIcon" svgClasses="w-5 h-5" /> -->
                </div>
                <!-- <p class="text-gray fsize12 mt-1">12+ Ongoing Chats</p> -->
                <div class="flex justify-between items-center w-full mt-6">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/Whatsapp/Sample5.png"
                    class="object-contain w-16 h-16 bg-ec rounded-full"
                    alt="banh"
                  />
                  <h2 class="text-5xl font-semibold col-89">
                    {{ PendingChat }}
                  </h2>
                </div>
              </div>
              <div
                class="p-8 shadow-md bg-white border rounded-lg"
                @click="filterStatus('Closed')"
              >
                <div class="flex justify-between items-center w-full">
                  <h5 class="text-xl text-primary font-semibold">
                    Closed Chats
                  </h5>
                  <!-- <feather-icon icon="ArrowRightIcon" svgClasses="w-5 h-5" /> -->
                </div>
                <!-- <p class="text-gray fsize12 mt-1">12+ Ongoing Chats</p> -->
                <div class="flex justify-between items-center w-full mt-6">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/Whatsapp/Sample6.png"
                    class="object-contain w-16 h-16 bg-ec rounded-full"
                    alt="banh"
                  />
                  <h2 class="text-5xl font-semibold col-89">
                    {{ ClosedChat }}
                  </h2>
                </div>
              </div>
              <div
                class="p-8 shadow-md bg-white border rounded-lg"
                @click="filterStatus"
              >
                <div class="flex justify-between items-center w-full">
                  <h5 class="text-xl text-primary font-semibold">
                    Expired Chats
                  </h5>
                  <!-- <feather-icon icon="ArrowRightIcon" svgClasses="w-5 h-5" /> -->
                </div>
                <!-- <p class="text-gray fsize12 mt-1">12+ Ongoing Chats</p> -->
                <div class="flex justify-between items-center w-full mt-6">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/Whatsapp/Sample.png"
                    class="object-contain w-16 h-16 bg-ec rounded-full"
                    alt="banh"
                  />
                  <h2 class="text-5xl font-semibold col-89">
                    {{ ExpiryChat }}
                  </h2>
                </div>
              </div>
              <div class="p-8 shadow-md bg-white border rounded-lg">
                <div class="flex justify-between items-center w-full">
                  <h5 class="text-xl text-primary font-semibold">
                    Avg. Response time
                  </h5>
                </div>
                <!-- <p class="text-gray fsize12 mt-1">12+ Ongoing Chats</p> -->
                <div class="flex justify-between items-center w-full mt-6">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/Whatsapp/Sample7.png"
                    class="object-contain w-16 h-16 bg-ec rounded-full"
                    alt="banh"
                  />
                  <h2 class="text-5xl font-semibold col-89">
                    {{ ResponseTime }}
                  </h2>
                </div>
              </div>
              <div class="p-8 shadow-md bg-white border rounded-lg">
                <div class="flex justify-between items-center w-full">
                  <h5 class="text-xl text-primary font-semibold">
                    Avg. Closure time
                  </h5>
                </div>
                <!-- <p class="text-gray fsize12 mt-1">12+ Ongoing Chats</p> -->
                <div class="flex justify-between items-center w-full mt-6">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/Whatsapp/Sample8.png"
                    class="object-contain w-16 h-16 bg-ec rounded-full"
                    alt="banh"
                  />
                  <h2 class="text-5xl font-semibold col-89">
                    {{ ClosureTime }}
                  </h2>
                </div>
              </div>
              <div class="p-8 shadow-md bg-white border rounded-lg">
                <div class="flex justify-between items-center w-full">
                  <h5 class="text-xl text-primary font-semibold">
                    All Contacts
                  </h5>
                  <!-- <feather-icon icon="ArrowRightIcon" svgClasses="w-5 h-5" /> -->
                </div>
                <!-- <p class="text-gray fsize12 mt-1">12+ Ongoing Chats</p> -->
                <div class="flex justify-between items-center w-full mt-6">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/Whatsapp/Sample2.png"
                    class="object-contain w-16 h-16 bg-ec rounded-full"
                    alt="banh"
                  />
                  <h2 class="text-5xl font-semibold col-89">
                    {{ AllContactLength }}
                  </h2>
                </div>
              </div>
              <div class="p-8 shadow-md bg-white border rounded-lg">
                <div class="flex justify-between items-center w-full">
                  <h5 class="text-xl text-primary font-semibold">Opt In</h5>
                </div>
                <!-- <p class="text-gray fsize12 mt-1">12+ Ongoing Chats</p> -->
                <div class="flex justify-between items-center w-full mt-6">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/Whatsapp/Sample10.png"
                    class="object-contain w-16 h-16 bg-ec rounded-full"
                    alt="banh"
                  />
                  <h2 class="text-5xl font-semibold col-89">{{ OtpIn }}</h2>
                </div>
              </div>
              <div class="p-8 shadow-md bg-white border rounded-lg">
                <div class="flex justify-between items-center w-full">
                  <h5 class="text-xl text-primary font-semibold">Opt Out</h5>
                </div>
                <!-- <p class="text-gray fsize12 mt-1">12+ Ongoing Chats</p> -->
                <div class="flex justify-between items-center w-full mt-6">
                  <img
                    src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/Whatsapp/Sample9.png"
                    class="object-contain w-16 h-16 bg-ec rounded-full"
                    alt="banh"
                  />
                  <h2 class="text-5xl font-semibold col-89">{{ OptOut }}</h2>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Agents" name="second">
          <h2 class="text-black mt-4 font-semibold text-2xl">
            Agents overview
          </h2>
          <div class="grid grid-cols-3 gap-4 mt-5">
            <div
              class="p-8 shadow-md bg-white border rounded-lg"
              @click="GTetRM()"
            >
              <div class="flex justify-between items-center w-full">
                <h5 class="text-xl text-primary font-semibold">Total Agents</h5>
              </div>

              <div class="flex justify-between items-center w-full mt-6">
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/Whatsapp/Sample1.png"
                  class="object-contain w-16 h-16 bg-ec rounded-full"
                  alt="banh"
                />
                <h2 class="text-5xl font-semibold col-89">
                  {{ rmrecordlist.result.length }}
                </h2>
              </div>
            </div>
            <div
              class="p-8 shadow-md bg-white border rounded-lg"
              @click="getAssignegRMList()"
            >
              <div class="flex justify-between items-center w-full">
                <h5 class="text-xl text-primary font-semibold">
                  Assigned Agents
                </h5>
              </div>

              <div class="flex justify-between items-center w-full mt-6">
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/Whatsapp/Sample5.png"
                  class="object-contain w-16 h-16 bg-ec rounded-full"
                  alt="banh"
                />
                <h2 class="text-5xl font-semibold col-89">
                  {{ assignedAgentList.length }}
                </h2>
              </div>
            </div>
            <div
              class="p-8 shadow-md bg-white border rounded-lg"
              @click="getUnassignedRMList()"
            >
              <div class="flex justify-between items-center w-full">
                <h5 class="text-xl text-primary font-semibold">
                  unassigned Agents
                </h5>
              </div>
              <div class="flex justify-between items-center w-full mt-6">
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/Whatsapp/Sample4.png"
                  class="object-contain w-16 h-16 bg-ec rounded-full"
                  alt="banh"
                />
                <h2 class="text-5xl font-semibold col-89">
                  {{ rmrecordlist.result.length - assignedAgentList.length }}
                </h2>
              </div>
            </div>
          </div>
          <div class="w-full flex gap-4 justify-between py-5">
            <div class="w-8/12 flex gap-3 items-center">
              <div class="relative w-8/12">
                <el-input v-model="search" placeholder="Search"></el-input>
                <div class="absolute top-0 right-0 m-2">
                  <feather-icon icon="SearchIcon" SvgClasses="w-4 h-4" />
                </div>
              </div>
              <div class="w-4/12">
                <el-select
                  v-model="sort"
                  placeholder="Sort by"
                  class="w-full border-2 rounded-lg"
                  @change="GTetRM"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <el-table
            :data="allRm"
            border
            style="width: 100%"
            class="table-responsive mt-6"
            header-row-class-name="thead-light table-th-color"
          >
            <el-table-column
              label="Sr No."
              min-width="60px"
              type="index"
              :index="indexmethod"
            >
            </el-table-column>
            <el-table-column prop="city" label="Agent Name" min-width="150px">
              <template v-slot="{ row }">
                <P class="text-gray">{{ row.name }}</P>
              </template>
            </el-table-column>
            <el-table-column prop="city" label="Email ID" min-width="150px">
              <template v-slot="{ row }">
                <P class="text-gray">{{ row.email }}</P>
              </template>
            </el-table-column>
            <el-table-column prop="city" label="Mobile no." min-width="150px">
              <template v-slot="{ row }">
                <P class="text-gray">{{ row.mobile }}</P>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="city"
              label="Chat Assigned"
              min-width="150px"
            >
              <template v-scope="{row}">
                <P class="text-gray">{{ '500' }}</P>
              </template>
            </el-table-column>
            <el-table-column prop="city" label="Closed Chat" min-width="150px">
              <template slot-scope="">
                <P class="text-gray">200</P>
              </template>
            </el-table-column>
            <el-table-column
              prop="city"
              label="Avg. Response time"
              min-width="150px"
            >
              <template slot-scope="">
                <P class="text-gray">15</P>
              </template>
            </el-table-column>
            <el-table-column
              prop="city"
              label="Avg. Closure time"
              min-width="150px"
            >
              <template slot-scope="">
                <P class="text-gray">15</P>
              </template>
            </el-table-column> -->
            <el-table-column prop="city" label="Status" min-width="150px">
              <template v-slot="{ row }">
                <div
                  class="px-3 py-1 border-liprimary cursor-pointer rounded-full flex items-center justify-center assign"
                  v-if="row.assigned"
                >
                  <p class="text-primary">Assigned</p>
                </div>
                <div
                  class="px-3 py-1 border-liprimary cursor-pointer rounded-full flex items-center justify-center assign"
                  v-else
                >
                  <p class="text-primary">Un Assigned</p>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="w-full flex justify-end mt-6">
            <el-pagination
              background
              :per-page="10"
              layout="prev,pager,next"
              :total-rows="Total_row"
              v-model="currentPage"
            ></el-pagination></div
        ></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import ChatAction from "../../whatsapp/store/chat/moduleChatActions";
import FeatherIcon from "../../../../../../../../components/FeatherIcon.vue";
import axios from "../../../../../../../../Apicall/whatsAppRepository";
const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
export default {
  data() {
    return {
      FeatherIcondrawer: false,
      drawer2: false,
      activeName: "first",
      centerDialogVisibleg: false,
      centerDialogVisiblef: false,
      tableData: [
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
      ],
      options: [
        { label: "Newest", value: -1 },
        { label: "Oldest", value: 1 },
      ],
      assignedAgentList: [],
      OtpIn: 0,
      OptOut: 0,
      AllContactLength: 0,
      AllContact: null,
      AssignChat: 0,
      ClosedChat: 0,
      PendingChat: 0,
      ExpiryChat: 0,
      ResponseTime: 0,
      ClosureTime: 0,
      currentPage: 1,
      sort: "",
      search: "",
      allRm: null,
    };
  },
  computed: {
    Total_row() {
      if (this.rmrecordlist.totalcount[0] != undefined) {
        return Number(this.rmrecordlist.totalcount[0].count);
      } else {
        return 0;
      }
    },
    ...mapState("admin", {
      login: "login",
    }),
    ...mapState("AgentRouting", {
      assignmono: "assignmono",
      checkStatus: "checkStatus",
      assignStatus: "assignStatus",
      checknumber: "checknumber",
    }),
    ...mapGetters("whatsappChat", {
      contacts: "contacts",
    }),
    ...mapState("AgentRouting", {
      assignmono: "assignmono",
      rmrecordlist: "rmrecordlist",
      getassigned: "getassigned",
      assignStatus: "assignStatus",
      allassignagent: "allassignagent",
      checknumber: "checknumber",
      assignmono: "assignmono",
    }),
  },
  watch: {
    search: {
      handler: debounce(async function (val) {
        this.GTetRM();
      }, 500),
    },
  },
  methods: {
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 5;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    async filterStatus(datas) {
      const payload = {
        status: datas,
      };
      let { data } = await this.$store.dispatch(
        "AgentRouting/statusFilter",
        payload
      );
      if (data) {
        let result = [];
        for (let i = 0; i < data.length; i++) {
          let results = this.AllContact.filter((val) => {
            // console.log(val);
            const str = data[i].number;
            const num = Number(str);
            const isnumber = !isNaN(num);

            return val.phone.includes(data[i].number);
          });
          result.push(results[0]);
        }
        console.log(result);
        await this.$store.commit("whatsappChat/SET_SEARCH_RESULTS", result);
        // await this.$router.push({ name: "whatsapp-bot" });
      }
      await this.$router.push({ name: "whatsapp-bot" });
    },
    async GetOptin() {
      return new Promise((resolve, reject) => {
        axios
          .get("/optin/getAllOptinUser")
          .then((res) => {
            console.log(res.data.users, "res");
            for (let i = 0; i < res.data.users.length; i++) {
              if (res.data.users[i].optinStatus) {
                this.OtpIn++;
              } else {
                this.OptOut++;
              }
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async fetchContacts() {
      let payload = {};
      if (this.assignmono.length > 0) {
        Object.assign(payload, { number: this.assignmono[0].assignedNumber });
      }
      return new Promise((resolve, reject) => {
        console.log("contact payload");
        axios
          .post("/contact/", payload)
          .then((response) => {
            console.log(response, "ress");
            this.AllContactLength = response.data.length;
            this.AllContact = response.data;
            for (let i = 0; i < response.data.length; i++) {
              this.checkhours(response.data[i].phone);
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
      // let responce = await this.$store.dispatch(
      //   "whatsappChat/fetchContacts",
      //   payload
      // );
    },
    checkhours(phone) {
      for (let i = 0; i < this.allassignagent.length; i++) {
        if (this.allassignagent[i].usermno == phone) {
          console.log(this.allassignagent[i], "vvvvvvvvvvvvvvvvvvvvvvvvv");
          let curdate = new Date();
          let timediff = Math.abs(
            curdate.getTime() -
              new Date(this.allassignagent[i].updatedAt).getTime()
          );
          let hours = Math.floor(timediff / (1000 * 60 * 60));

          if (this.allassignagent[i].isreply == false) {
            let status = Number(24 - hours);
            console.log(status);
            if (status < 0) {
              this.ExpiryChat++;
            } else {
              this.PendingChat++;
            }
          } else {
            this.AssignChat++;
            // return "Assigned";
          }
        }
      }
      console.log("falseeeee");
      return null;
      // var result=  this.allassignagent.filter((val) => {
      console.log(val, "valval");
      //  return val.usermno == phone
      // });
      // if(result.length>0){

      //   let curdate = new Date();
      //           let timediff = Math.abs(
      //             curdate.getTime() - new Date(result[0].updatedAt).getTime()
      //           );
      //           this.gethours = Math.floor(timediff / (1000 * 60 * 60));
      //             this.gethours=24-this.gethours
      //         console.log(this.gethours,"ppppppppppppppppppppppp")

      // }else{
      //     this.gethours="Not Assign"
      //   console.log("notr assign")

      // }
    },
    async GetAllassignchat() {
      // 'agent/GetAllassignchat'
      try {
        await this.$store.dispatch("AgentRouting/GetAllassignchat");
      } catch (err) {
        console.log(err);
      }
    },
    async Average() {
      return new Promise((resolve, reject) => {
        axios
          .post("/message/Average")
          .then((res) => {
            console.log(res.data, "Average");
            this.ResponseTime = res.data.Average.toFixed(2);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async GetAssigned(data) {
      try {
        let payload = {};
        if (data) {
          Object.assign(payload, { filter: data });
        }

        await this.$store.dispatch("AgentRouting/GetAssigned", payload);
        // this.assignedAgentList = [];
        this.setAgentList();
      } catch (Err) {
        console.log(Err);
      }
    },
    async Closure() {
      try {
        const payload = {};
        let data = await this.$store.dispatch(
          "AgentRouting/AverageClosure",
          payload
        );
        console.log(data, "dataaaa");
        this.ClosureTime = data.data.toFixed(2);
      } catch (Err) {
        console.log(Err);
      }
    },
    async GTetRM() {
      let payload = {
        role: "RM",
        search: this.search,
        offset:
          this.currentPage >= 1 ? (this.currentPage - 1) * 5 : this.currentPage,
      };
      if (this.sort == -1) {
        Object.assign(payload, { sort: -1 });
      } else if (this.sort == 1) {
        Object.assign(payload, { sort: 1 });
      }
      try {
        await this.$store.dispatch("AgentRouting/getRmList", payload);
        // this.allRm = this.rmrecordlist.result;
        await this.setAgentList();
      } catch (err) {
        console.log(err);
      }
    },
    async getUnassignedRMList() {
      // console.log(this.assignedAgentList);
      await this.GTetRM();
      await this.setAgentList();
      let results = [];
      for (let i = 0; i < this.assignedAgentList.length; i++) {
        let result = await this.allRm.filter((x) => {
          return x._id != this.assignedAgentList[i].rmId;
        });
        if (result[0]) {
          results.push(result[0]);
        }
      }

      this.allRm = results;
    },
    async getAssignegRMList() {
      await this.GTetRM();
      await this.setAgentList();
      let results = [];
      for (let i = 0; i < this.assignedAgentList.length; i++) {
        let result = await this.allRm.filter((x) => {
          return x._id.includes(this.assignedAgentList[i].rmId);
        });
        if (result[0]) {
          results.push(result[0]);
        }
      }

      this.allRm = results;
    },
    async setAgentList() {
      this.assignedAgentList = [];
      for (let i = 0; i < this.rmrecordlist.result.length; i++) {
        let result = await this.getassigned.result.filter((x) => {
          if (x.rmId.includes(this.rmrecordlist.result[i]._id)) {
            Object.assign(this.rmrecordlist.result[i], { assigned: true });
          } else {
            Object.assign(this.rmrecordlist.result[i], { assigned: false });
          }
          return x.rmId.includes(this.rmrecordlist.result[i]._id);
        });
        if (result[0]) {
          this.assignedAgentList.push(result[0]);
        }
      }
      this.allRm = this.rmrecordlist.result;
    },
  },
  async mounted() {
    await this.GetOptin();
    // await this.GetUserMno()
    await this.fetchContacts();
    await this.GetAllassignchat();
    await this.GetAssigned();
    this.Average();
    await this.Closure();
    await this.GTetRM();
    await this.setAgentList();
    console.log(this.rmrecordlist, "uiguyguyi");
    // for (let i = 0; i < this.contacts.length; i++) {
    //   console.log(this.contacts[i].phone, "contactsssssss");
    // }
  },
};
</script>
